import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useReportsData } from '../../hooks/useReportsData';
import { Eye, Loader2, AlertTriangle, CheckCircle2, Shield } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Progress } from '../../components/ui/progress';

export const MonitoringReport = () => {
    const [searchParams] = useSearchParams();
    const filters = { client: searchParams.get('client') };
    const { alerts, loading } = useReportsData(filters);

    if (loading) return <div className="p-12 flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-gray-400" /></div>;

    return (
        <div className="space-y-6 animate-in fade-in duration-500">
            <div className="flex justify-between items-center">
                <h2 className="text-xl font-bold text-gray-900">Monitoreo & Gaceta</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <Card>
                    <CardHeader className="pb-2"><CardTitle className="text-sm font-medium text-gray-500">Alertas Totales</CardTitle></CardHeader>
                    <CardContent><div className="text-2xl font-bold">{alerts.length}</div></CardContent>
                </Card>
                <Card>
                    <CardHeader className="pb-2"><CardTitle className="text-sm font-medium text-gray-500">Alta Similitud (&gt;80%)</CardTitle></CardHeader>
                    <CardContent><div className="text-2xl font-bold text-red-600">{alerts.filter(a => a.score > 80).length}</div></CardContent>
                </Card>
                <Card>
                    <CardHeader className="pb-2"><CardTitle className="text-sm font-medium text-gray-500">Oposiciones Iniciadas</CardTitle></CardHeader>
                    <CardContent><div className="text-2xl font-bold text-blue-600">{alerts.filter(a => a.status === 'Enviado a procedimiento').length}</div></CardContent>
                </Card>
            </div>

            <Card>
                <CardHeader>
                    <CardTitle>Resultados de Vigilancia</CardTitle>
                    <CardDescription>Coincidencias fonéticas y gráficas en nuevas publicaciones</CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                    {alerts.map(alert => (
                        <div key={alert.id} className="border rounded-lg p-4 bg-white hover:bg-gray-50 transition-colors">
                            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                                <div className="flex items-start gap-4 flex-1">
                                    <div className={`p-2 rounded-lg ${alert.score > 80 ? 'bg-red-100 text-red-600' : 'bg-orange-100 text-orange-600'}`}>
                                        {alert.score > 80 ? <AlertTriangle className="h-6 w-6" /> : <Eye className="h-6 w-6" />}
                                    </div>
                                    <div>
                                        <div className="flex items-center gap-2 mb-1">
                                            <h4 className="font-bold text-gray-900">{alert.detected}</h4>
                                            <span className="text-xs px-2 py-0.5 bg-gray-100 rounded-full font-medium">Vs {alert.watched}</span>
                                        </div>
                                        <p className="text-sm text-gray-500">
                                            Similitud: {alert.similarity} • Publicado: {alert.date}
                                        </p>
                                    </div>
                                </div>

                                <div className="flex items-center gap-6 flex-1 md:max-w-xs">
                                    <div className="flex-1">
                                        <div className="flex justify-between text-xs mb-1">
                                            <span>Coincidencia</span>
                                            <span className="font-bold">{alert.score}%</span>
                                        </div>
                                        <Progress value={alert.score} className={`h-2 ${alert.score > 80 ? 'bg-red-100' : 'bg-orange-100'}`} indicatorClassName={alert.score > 80 ? 'bg-red-500' : 'bg-orange-500'} />
                                    </div>
                                    <div className="text-right min-w-[100px]">
                                        <span className="text-xs font-semibold block uppercase text-gray-500 mb-1">{alert.status}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </CardContent>
            </Card>
        </div>
    );
};
